/*
 * This code was generated with assistance from GitHub Copilot.
 * De-bundled from react-dxd-components@0.1.33 compiled dist/index.js (webpack module id 3).
 */

export const LABEL_TYPES = {
  ARIA: 'aria',
  VISIBLE: 'visible',
  WHITESPACE_FOR_ALIGNMENT: 'whitespace',
} as const;

export type LabelType = (typeof LABEL_TYPES)[keyof typeof LABEL_TYPES];

